module.exports = __webpack_public_path__ + "static/Wave-7a8f2fa2554038dae28a876d4993d87f.png";